import { useState, useEffect } from 'react';
import { Loader2, MessageCircle, Zap, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function PublicChatConvertingOverlay() {
  const [currentStep, setCurrentStep] = useState(0);
  const [dots, setDots] = useState('');
  const { t } = useTranslation('chat');

  const steps = [
    { icon: Zap, text: t('converting-overlay.heating-up'), duration: 2000 },
    { icon: MessageCircle, text: t('converting-overlay.converting'), duration: 3000 },
    { icon: CheckCircle, text: t('converting-overlay.almost-ready'), duration: 2000 },
  ];

  // Animate dots
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : prev + '.'));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  // Progress through steps
  useEffect(() => {
    if (currentStep < steps.length - 1) {
      const timer = setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
      }, steps[currentStep].duration);
      return () => clearTimeout(timer);
    }
  }, [currentStep]);

  const CurrentIcon = steps[currentStep]?.icon || Loader2;

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center z-50">
      <div className="text-center max-w-md px-8">
        {/* Main animation */}
        <div className="mb-8">
          <div className="relative mx-auto w-24 h-24 mb-6">
            {/* Outer pulse ring */}
            {/* <div className="absolute inset-0 rounded-full bg-blue-400 opacity-20 animate-ping"></div> */}
            {/* Middle pulse ring */}
            <div className="absolute inset-2 rounded-full bg-blue-400 opacity-40 animate-ping"></div>
            {/* Inner solid circle */}
            <div className="absolute inset-4 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center">
              <CurrentIcon className="w-8 h-8 text-white animate-pulse" />
            </div>
          </div>
        </div>

        {/* Current step text */}
        <div className="text-xl font-medium text-gray-900 mb-2">
          {steps[currentStep]?.text}
          <span className="inline-block w-8 text-left">{dots}</span>
        </div>

        {/* Encouraging message */}
        <p className="text-sm text-gray-500 leading-relaxed">{t('converting-overlay.description')}</p>

        {/* Progress bar */}
        <div className="mt-6 w-full bg-gray-200 rounded-full h-1 overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-blue-500 to-purple-600 transition-all duration-1000 ease-out"
            style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
}
